import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "キャッシュクリア", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "奉行クラウドの勘定科目と一致しないときに実行してください。", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "キャッシュをクリアする", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _hoisted_2,
      _createVNode(_component_loading_button, {
        color: "warning",
        onClick: _ctx.onClickedExport,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick", "loading"]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceed,
        "success-message": "キャッシュをクリアしました。",
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"])
    ]),
    _: 1
  }))
}